import React, { PureComponent } from 'react';

class CabeceraRenglonAsiento extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="AsientosContables__modalDetalleAsiento__cabeceraGrilla AsientosContables__modalDetalleAsiento__cabeceraGrilla--noBorderBottom">
                <div className="AsientosContables__modalDetalleAsiento__cabeceraGrillaRenglon AsientosContables--floatLeft">
                    RENGLÓN
                </div>

                <div className="AsientosContables__modalDetalleAsiento__cabeceraGrillaCuentaContable AsientosContables__modalDetalleAsiento__cabeceraGrillaCuentaContable--widthDetalleAsiento AsientosContables--floatLeft">
                    CUENTA CONTABLE
                </div>

                <div className="AsientosContables__modalDetalleAsiento__cabeceraGrillaDebe AsientosContables--floatLeft">
                    DEBE
                </div>

                <div className="AsientosContables__modalDetalleAsiento__cabeceraGrillaHaber AsientosContables--floatLeft">
                    HABER
                </div>

                <div className="AsientosContables__modalDetalleAsiento__cabeceraGrillaBotonDesplegable AsientosContables--floatLeft">
                </div>
            </div>
        )
    }
}

export default CabeceraRenglonAsiento;